
import React from "react";
import { Modal } from '@themesberg/react-bootstrap';
import DirectionPathButton from "../../components/widgets/directionPathButton";


function NotFoundInspect () {

  return (
    <Modal
        show={true}
        // onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Advertencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Peritaje invalido o inaccesible, contactese con el administrador
        </Modal.Body>
        <Modal.Footer>
          <DirectionPathButton path="/inspectionreport"  text="Regresar"/>
        </Modal.Footer>
      </Modal>
  );
};

export default NotFoundInspect;
